import React from 'react';
import Modal from 'react-modal';
import './modal.css'

interface ModalProps {
    showConfirmation: boolean;
    confirmExclusao: () => void;
    cancelarExclusao: () => void;
    textoExclusao : string;
}

function ModalDeConfirmacao({ showConfirmation, confirmExclusao, cancelarExclusao, textoExclusao }: ModalProps) {
    return (
        <Modal
            isOpen={showConfirmation}
            onRequestClose={cancelarExclusao}
            contentLabel="Confirmação de Exclusão"
            overlayClassName={'modalOverlay'}
            className={'modalSupremo'}
        >
            <div className='modalConfirmacao'>
                <h2>{textoExclusao}</h2>
                <div>
                <button onClick={cancelarExclusao} className="btn btn-danger botao">Não</button>
                    <button onClick={confirmExclusao} className="btn btn-primary botao">Sim</button>
                </div>
            </div>
        </Modal>
    );
}

export default ModalDeConfirmacao;
